// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1PtcK","unreadBadge":"styles_unreadBadge__28knp","modalContent":"styles_modalContent__2kQdZ","modal":"styles_modal__2ZkyD"};